import type { TaskResponse } from "@patent-studio/api-types";

/** Shown when no draft is open — the wireframe's placeholder, not a stored title. */
const NO_DRAFT_TITLE = "Untitled application";

/**
 * The app-wide draft display rule, so a draft reads the same wherever it is
 * shown. Distinct from `"Untitled Draft"`, which v1 *stores* on a title-less
 * create: this one is only ever displayed.
 */
export function resolveDraftTitle(
  task: Pick<TaskResponse, "title" | "working_title"> | undefined,
): string {
  if (!task) return NO_DRAFT_TITLE;
  return task.working_title ?? task.title;
}
